import { Uid, ObjectWithUid } from "../utils.tsx";
import { ResponseWrapper, PagedResults, trackerGet, trackerPost, trackerDelete, trackerPatch, decodeResult } from "./basicApi.ts";
import { SampleConfiguration, SampleConfigurationSet } from '../sampleSets.ts';


interface SampleSetDto extends ObjectWithUid {
  slug: string;
  // Intended to be short and unique within an ESAF, but this is not strictly enforced.
  name: string;
  // Meant to be longer than the name.  Can be blank.
  description: string;
  slug_esaf: string;
  slug_beamline: string;
  slug_proposal: string;
  scan_status: string;
  id_most_recent_editor: number;
  date_last_modified: string;
  slugs_samples: string[];
}


interface SampleSetCreateDto {
  // Intended to be short and unique, but this is not strictly enforced.
  name: string;
  // Meant to be longer than the name.  Can be blank.
  description: string;
  slug_esaf: string;
}


interface SampleSetUpdateDto {
  slug: string;
  // Intended to be short and unique, but this is not strictly enforced.
  name?: string;
  scan_status?: string;
  // Meant to be longer than the name.  Can be blank.
  description?: string;
}



// Get one Set by slug.
async function getSetBySlug(slug: string): Promise<ResponseWrapper<SampleSetDto>> {
  const result = await trackerGet(`sets/${slug}/`, {});
  return decodeResult(result);
}


// Get all the Sets for the given ESAF the logged-in user has access to.
async function getSetsForEsaf(slug: string): Promise<ResponseWrapper<PagedResults<SampleSetDto>>> {
  const params = { esaf__slug: slug };
  const result = await trackerGet(`sets/`, params);
  return decodeResult(result);
}


// Create a Set record on the server.
async function createSet(dto: SampleSetCreateDto): Promise<ResponseWrapper<SampleSetDto>> {
  const result = await trackerPost(`sets/`, JSON.stringify(dto));
  return decodeResult(result);
}


// Update a Set record on the server.
async function updateSet(dto: SampleSetUpdateDto): Promise<ResponseWrapper<SampleSetDto>> {
  const result = await trackerPatch(`sets/${dto.slug}/`, JSON.stringify(dto));
  if (result.success) {
   const body:any = await result.response!.json();
   return { success: true, response: body };
 }
 return { success: false, message: result.message };
}


// Delete a Set record from the server, returning the Id used if successful.
async function deleteSet(setSlug: string): Promise<ResponseWrapper<string>> {
  const result = await trackerDelete(`sets/${setSlug}/`, {});
 if (result.success) {
   return { success: true, response: setSlug };
 }
 return { success: false, message: result.message };
}


export type { SampleSetDto, SampleSetCreateDto, SampleSetUpdateDto };
export { getSetBySlug, getSetsForEsaf, createSet, updateSet, deleteSet }
